module.exports = __webpack_public_path__ + "img/WalnutImage.7eff852e.jpg";